"use strict";require("core-js/modules/es.date.to-string");require("core-js/modules/es.object.to-string");require("core-js/modules/es.regexp.exec");require("core-js/modules/es.regexp.to-string");require("core-js/modules/es.string.split");exports.__esModule = true;exports.getFullType = getFullType;exports.castObj = castObj;exports.hasProp = hasProp;exports.objGet = objGet;
var _is = require("./is");


// export function mergeObj<TA, TB>( a: TA, b: TB ): $Rest<TA, TB> {
//   return Object.assign( {}, a, b )
// }


/**
 * @namespace __Object
 */


/**
     * Возвращает полный тип передаваемого аргумента
     *
     *
     * @param {*} some
     * @example
     * getFullType( [] ) // [object Array]
     * getFullType( null ) // [object Null]
     * @returns {string} [object Number]
     * @memberof __Object
     */
function getFullType(some) {
  return Object.prototype.toString.call(some);
}

/**
   * Возвращает аргумент, если он - объект, либо пустой объект
   *
   *
   * @param {*} maybeObj
   * @example
   * castObj( { x: 3 } ) // { x: 3 }
   * castObj( undefined ) // {}
   * @returns {{ [ string ]: * }}
   * @memberof __Object
   */
function castObj(maybeObj) {
  return (0, _is.isObj)(maybeObj) ? maybeObj : {};
}

/**
   * Проверяет если ли у объекта свойства
   *
   *
   * @param {{ [ string ]: * }} obj
   * @param {string} propName
   * @example
   * hasProp( { x: 3 }, 'x' ) // true
   * hasProp( { x: 3 }, 'QWE' ) // false
   * @returns {boolean}
   * @memberof __Object
   */
function hasProp(obj, propName) {
  return Object.prototype.hasOwnProperty.call(obj, propName);
}




/**
   * Возвращает значение объекта по вложенному пути
   *
   *
   * @param {AnyMap} obj
   * @param {string} keysIn
   * @returns {*}
   * @memberof __Object
   */
function objGet(obj, keysIn) {
  var keys = keysIn.split('.');
  var result = obj;var
  length = keys.length;
  for (var i = 0; i < length; i++) {
    var key = keys[i];
    result = result[key];
    if (!(0, _is.isObj)(result) && !(0, _is.isArr)(result) && length !== i + 1) {
      return undefined;
    }
  }
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/obj.js
// module id = 37
// module chunks = 0